import { Injectable } from "@angular/core";
import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (
      typeof params.interpolateParams === 'object' &&
      params.interpolateParams !== null &&
      'default' in params.interpolateParams
    ) {
      return (params.interpolateParams as { default: string }).default;
    }

    return params.key;
  }
}